
import axios from "axios";
import { useAuthStore } from "../stores/authStore";

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://shopconnect.simbisabrands.com";

const api = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const message =
      error.response?.data?.message ||
      "Request failed.";

    if (status === 401) {
      useAuthStore.getState().signOut();

      window.dispatchEvent(
        new CustomEvent("spend2connect:unauthenticated", {
          detail: {
            message:
              "Your session has expired. Please sign in again.",
          },
        }),
      );
    }

    if (status === 403) {
      window.dispatchEvent(
        new CustomEvent("spend2connect:forbidden", {
          detail: {
            message,
          },
        }),
      );
    }

    return Promise.reject(error);
  },
);

export default api;
